// import node module libraries
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

const initialState = {
  theme: "light",
  isSidebarExpanded: true,
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
    },
    setIsExpanded: (state, action) => {
      state.isSidebarExpanded = action.payload;
    },
  },
});

export const { toggleTheme, setIsExpanded } = themeSlice.actions;

export const isSidebarExpanded = (state: RootState) =>
  state.theme.isSidebarExpanded;
export const theme = (state: RootState) => state.theme.theme;

export default themeSlice.reducer;
